const kpi = {
  title: 'סטטיסטיקות נוכחיות', 
};

export default kpi;